module.exports = __webpack_public_path__ + "static/media/Anfora_Gold_Love.9df9f34d.png";